<template>
  <div class="main-body">
    <div class="header">入住管理</div>
    <div class="out">
      <div class="search2">

        <el-button type="primary" size="mini" @click.native="toggleModalAdd">添加</el-button>

        <div style="float:right">

          <el-input placeholder="输入姓名" size="mini" v-model="elderlyName" clearable style="width:120px;margin-right: 10px;"></el-input>

          <el-select v-model="status" placeholder="入住状态" size="mini" style="margin-right: 10px;">
            <el-option
                v-for="item in statusArr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>

          <el-date-picker size="mini"
              style="width: 250px;margin-right: 10px;"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              v-model="search.date"
              type="daterange"
              align="right"
              placeholder="选择日期范围"
              :default-value="search.date"
              :picker-options="pickerOptions"
              range-separator=" ~ ">
          </el-date-picker>

          <el-button type="primary" size="mini" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th" v-loading="loading" border
                highlight-current-row @row-click='rowClick'>

        <el-table-column fixed prop="elderlyName" label="姓名" width="100px"></el-table-column>

        <el-table-column label="类型" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.checkinType == '1'">养老院</span>
            <span v-if="scope.row.checkinType == '2'">家庭养老床位</span>
            <span v-if="scope.row.checkinType == '3'">日间照料</span>
          </template>
        </el-table-column>

        <el-table-column label="状态" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.status == '1'" style="color:blue;">入住中</span>
            <span v-if="scope.row.status == '2'" style="color: gray;">已退住</span>
          </template>
        </el-table-column>

        <el-table-column prop="checkinSetmealName" label="护理套餐" width="120px"></el-table-column>

        <el-table-column prop="priceMonth" label="月费用" width="150px"></el-table-column>
        <el-table-column prop="univalenceTrue" label="实际费用" width="150px"></el-table-column>

        <el-table-column prop="elderlyFund.balance" label="余额" width="120px"></el-table-column>

        <el-table-column prop="beginTime" :formatter="timefilter" width="180" label="开始时间"></el-table-column>
        <el-table-column prop="endTime" :formatter="timefilter" width="180" label="结束时间"></el-table-column>


        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
<!--            <el-button size="mini" @click="handleInfo(scope.$index, scope.row)">详情</el-button>-->

            <span v-if="scope.row.status == '1'">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="settlefuc2(scope.$index, scope.row)">退住</el-button>
            </span>
            <span v-if="scope.row.status == '2'"></span>

          </template>
        </el-table-column>


      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <el-dialog title='结算' :visible.sync="settleDialog" class="dialog" width='600px' center top='30vh' :close-on-click-modal='false'>
      <el-form :model="settleForm" :rules="rules" ref="settleForm">
        <el-row>

          <el-col :span="12" class="item">
            <el-form-item label="结算待扣款金额" required prop="total">
              <el-input type="number" v-model="settleForm.total" placeholder="请输入扣款金额"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="item">
            <el-form-item label="余额">
              <el-input type="number" v-model="settleForm.balance" disabled></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24" class="item">
            <el-form-item label="备注">
              <el-input v-model="settleForm.remarks" type="textarea" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="settleDialog=false">取 消</el-button>
        <el-button type="primary" @click="settleSub('settleForm')">提交</el-button>
      </div>
    </el-dialog>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd"
         v-bind:setmealList="setmealList" v-on:getList="getList"></Add>

    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit"
          v-bind:ListBerth="ListBerth"  v-bind:setmealList="setmealList"
          v-on:getList="getList"></Edit>

    <Detail ref="myDetail" v-show="showModalDetail" v-on:closeDetail="closeDetail"></Detail>

  </div>
</template>

<script>

import Add from "./Add";
import Edit from "./Edit";
import Detail from "./Detail";

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Page",
  data() {
    return {
      loading: true,

      disabledAdd:false,
      disabledIn:true,
      disabledEdit:true,
      disabledSettlement:true,
      disabledRoomChange:true,
      disabledContract:true,
      disabledDetail:true,

      elderlyName:"",

      showModalAdd: false,

      showModalRoomChange: false,
      showModalZiXuanRoomChange:false,
      datetimerangeValue: '',

      showModalEdit: false,
      showModalZiXuanEdit:false,
      showModalDetail:false,
      batchDialog: false,
      settleDialog: false,
      elderlyBalance: '',

      settleForm: {
        moneyPlan: null,
        refundMoney: null,
        total: null,
        remarks: null,
        isRefund:2,
        balance:0,
      },

      rules:{
        totalMoney:[
          { required: true, message: '请输入实际结算金额', trigger: 'blur' },
          {
            pattern: /^(\d?)+(\.\d{0,2})?$/,
            message: '小数点后数字不能超过两位', trigger: 'blur'
          },
        ],
        remarks:[
          { required: true, message: '请输入备注', trigger: 'blur' },
        ],
        isRefund:[
          { required: true, message: '请选择是否退款', trigger: 'blur' },
        ],
      },


      ListBerth: null,
      setmealList: null,

      tableData: null,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,


      checkInfo:'',


      search: {
        date:[],
      },
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const end = new Date();
            end.setHours(23, 59, 59);
            const start = new Date(end);
            start.setTime(end.getTime() - 3600 * 1000 * 24 + 1000);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setHours(23, 59, 59);
            start.setTime(end.getTime() - 3600 * 1000 * 24 * 7 + 1000);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setHours(23, 59, 59);
            start.setTime(end.getTime() - 3600 * 1000 * 24 * 30 + 1000);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setHours(23, 59, 59);
            start.setTime(end.getTime() - 3600 * 1000 * 24 * 90 + 1000);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setHours(23, 59, 59);
            start.setTime(end.getTime() - 3600 * 1000 * 24 * 365 + 1000);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      status:-1,
      statusArr: [{
        value: -1,
        label: '全部状态'
      },{
        value: 1,
        label: '入住中'
      },{
        value: 2,
        label: '已退住'
      }],


    }
  },

  created() {

    const end = new Date();
    const start = new Date(end - 1000 * 60 * 60 * 24 * 360);
    this.search.date = [start, end];


    this.init();
    this.getList();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
  },
  components: {
    Add,Edit,Detail
  },
  methods: {

    timefilter(row, column, cellValue){
      return timefilters(cellValue)
    },

    monthFirstDay:function (time) {  //是我用来获取当月的第一天的
      let date = new Date(time)
      let year = date.getFullYear()
      let month = (date.getMonth() + 1) > 10 ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))
      let day = '01';
      return `${year}-${month}-${day}`

    },
    nowDay:function (time) { //handleTimeNew是获取今天的日期
      let date = new Date(time)
      let year = date.getFullYear()
      let month = (date.getMonth() + 1) > 10 ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))
      let day = date.getDate() > 10 ? date.getDate() : ('0' + date.getDate())
      return `${year}-${month}-${day}`
    },

    init(){
      this.getSetMeal();
    },

    getSetMeal:function (){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CheckinSetmeal/List",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.setmealList=response.data.data
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },

    settlefuc2(index,row){
      this.checkInfo = row;

      this.settleForm.total=0;
      this.settleForm.balance = row.elderlyFund.balance;

      this.settleDialog=true

    },
    settleSub(settleForm){
      this.$refs[settleForm].validate((valid) => {
        if(valid){

          var checkinCode=this.checkInfo.checkinCode

          this.$axios({
            method: 'post',
            url: this.$shopUrl + "Checkin/RetreatSettleDayCare",
            data: {
              timeStr: timeStr,
              sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
              staffCode: getStaffCode(),
              checkinCode:checkinCode,
              remarks:this.settleForm.remarks,
              total:this.settleForm.total,
              //isRefund:this.settleForm.isRefund,
              //refundMoney:refundMoney,
            }
          }).then((response) => {
            //console.log(response);
            if (response.data.error == 0) {
              this.settleDialog=false
              this.$refs.settleForm.resetFields();
              this.getList()
            } else if (response.data.error == 1) {
              this.$message({type: 'info', message: response.data.message});
            }
          }).catch(function (error) {
            console.log(error);
          });
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },






    handleInfo(index,row) {
      this.$refs.myDetail.init(row);
      this.showModalDetail = !this.showModalDetail;
    },
    closeDetail: function () {
      this.showModalDetail = !this.showModalDetail;
    },



    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },

    handleEdit(index,row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList() {

      if(this.search.date == null){
        this.search.date = ['',''];
      }

      this.loading = true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Checkin/Page",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          elderlyName:this.elderlyName,
          status:this.status,
          startTime: this.search.date[0],
          endTime: this.search.date[1],
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
        }
      }).then((response) => {
        //console.log(response);
        this.loading = false;

        if (response.data.error == 0) {
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },




    rowClick(row){
      this.checkInfo=row
    }

  }
}
</script>
